// api/services/sitetags.ts
import { fetchCustomerResource, handleRequest } from '@/api';
import type { SiteTag } from '@/types';

interface CustomerRef {
    id: number;
}

interface SiteTagPayload {
    customer_id: number;
    tag_description: string;
}

interface SiteTagUpdatePayload extends SiteTagPayload {
    id: number;
}

interface SiteTagOperationResponse {
    message: string;
    site_tag_id: number;
}

export const getSiteTagsForCustomer = (customer: CustomerRef, signal?: AbortSignal): Promise<SiteTag[]> =>
    fetchCustomerResource<SiteTag[]>('sitetags', customer.id, signal);

export const saveNewSiteTag = (payload: SiteTagPayload): Promise<SiteTagOperationResponse> =>
    handleRequest<SiteTagOperationResponse>('post', `/sitetags/`, payload, 'Site tag saved successfully!');

export const updateSiteTag = (payload: SiteTagUpdatePayload): Promise<SiteTagOperationResponse> =>
    handleRequest<SiteTagOperationResponse>(
        'put',
        `/sitetags/${payload.id}`,
        payload,
        'Site tag updated successfully!'
    );
